import { Box, BoxProps } from "@hightouch/htui";

import { LIFECYCLE_STUDIO_ICON_PATH } from "src/ui/icons/lifecycle-studio";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d={LIFECYCLE_STUDIO_ICON_PATH} />
  </Box>
);
